import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { iconMarkup } from "../iconify.ts";

var root = $.from_svg(`<svg aria-hidden="true" class="icon" viewBox="0 0 24 24"></svg>`);

export default function Icon($$anchor, $$props) {
	$.push($$props, true);

	var svg = root();

	$.html(svg, () => iconMarkup($$props.name), true);
	$.reset(svg);
	$.append($$anchor, svg);
	$.pop();
}